import { type ClassValue, clsx } from "clsx";
import { extendTailwindMerge } from "tailwind-merge";

const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      "font-size": [
        {
          text: [
            "body1",
            "body2",
            "body3",
            "bold1",
            "bold2",
            "bold3",
            "button",
            "chip",
            "display",
            "h1",
            "h2",
            "h3",
            "sub1",
            "sub2",
            "title",
          ],
        },
      ],
      "text-shadow": ["text-shadow", "text-shadow-subtle"],
    },
  },
});

export const cn = (...inputs: ClassValue[]) => {
  return twMerge(clsx(inputs));
};

export const removeNonDigits = (inputValue: string) => inputValue.replace(/[^\d]/g, "");

export const convertToFullName = (firstName: string, lastName: string) =>
  `${firstName ? firstName.charAt(0).toUpperCase() + firstName.slice(1) : ""} ${
    lastName ? lastName.charAt(0).toUpperCase() + lastName.slice(1) : ""
  }`.trim();
